import React, { useCallback, useContext } from 'react'
import {
    FaAngleUp,
    FaAngleDown,
    FaCompressArrowsAlt,
    FaExpandArrowsAlt,
} from 'react-icons/fa'
import dayjs from 'dayjs'

import { IconContext } from 'react-icons'
import { IconTooltip as Tooltip } from '../../../elem/Tooltip'
import PanelHeader from '../../../elem/panel/PanelHeader'
import { DataContext } from './DataContext'
import ResetDropDownButton from '../../../elem/chart/ResetDropDownButton'
import ParamSelectorButton from '../../../elem/chart/ParamSelectorButton'
import ChartDownloadButton from '../../../elem/chart/ChartDownloadButton'
import { AppStateContext } from '../AppStateContext'
import ExpandButton from '../../../elem/list/ExpandButton'
import { PanelStyleContext } from '../../../elem/panel/PanelStyleContext'
import CollapseButton from '../../../elem/list/CollapseButton'
import downloadChartXlsx from '../../../../utils/chart/downloadChartXlsx'

const formatAggregateValue = value => {
    if (value === null || value === undefined || value === '') return ''
    const num = Number(value)
    if (Number.isNaN(num)) return value
    return Math.round(num * 100) / 100
}

export default ({}) => {
    const {
        displayParamWindowDropdown,
        toggleParamWindowDropdown,
        paramList,
        setCollapsed,
        isCollapsed,
        resetExpanded,
        toggleResetExpanded,
        paramChartData,
        selectedParams,
        chartVisibleRange,
        dateParams,
    } = useContext(DataContext)

    const { isExpanded, setIsExpanded } = useContext(PanelStyleContext)

    const handleDownload = useCallback(() => {
        if (!selectedParams || !selectedParams.length || !paramChartData || !paramChartData.length) {
            return
        }
        const left = chartVisibleRange && chartVisibleRange.left
        const right = chartVisibleRange && chartVisibleRange.right
        const isZoomed = typeof left === 'number' && typeof right === 'number'

        const rows = []
        selectedParams.forEach(param => {
            const series = paramChartData.find(c => c.ParamID === param.ParamID)
            if (!series || !series.Data) return
            series.Data.forEach(entry => {
                const ts = dayjs(entry.DateString).toDate().getTime()
                if (isZoomed && (ts < left || ts > right)) return
                rows.push({
                    _ts: ts,
                    'Sample Date': dayjs(entry.DateString).format('MM/DD/YYYY'),
                    'Parameter Name': `${param.ParamAlias} - ${param.Units}`,
                    '# Samples': entry.NumberOfSamples,
                    'Max': formatAggregateValue(entry.Maximum),
                    'Median': formatAggregateValue(entry.Median),
                    'Min': formatAggregateValue(entry.Minimum),
                })
            })
        })

        rows.sort((a, b) => {
            const dateCompare = a._ts - b._ts
            if (dateCompare !== 0) return dateCompare
            return (a['Parameter Name'] || '').localeCompare(b['Parameter Name'] || '')
        })
        rows.forEach(r => delete r._ts)

        const [filterStart, filterEnd] = dateParams || [null, null]
        const sampleDateFilterApplied = !!(filterStart || filterEnd)

        downloadChartXlsx({
            headers: ['Sample Date', 'Parameter Name', '# Samples', 'Max', 'Median', 'Min'],
            rows,
            prefix: '',
            chartName: 'Aggregate Chemistry Sample Results Chart',
            sampleDateFilterApplied,
            isZoomed,
        })
    }, [paramChartData, selectedParams, chartVisibleRange, dateParams])

    const downloadDisabled =
        !selectedParams ||
        !selectedParams.length ||
        !paramChartData ||
        !paramChartData.length

    return (
        <PanelHeader extraClass={'aggregatePanelHeader'}>
            <div className="panelHeaderText">
                Aggregate Chemistry Sample Results Chart
            </div>
            <div className="panelButtons">
                <ResetDropDownButton
                    resetExpanded={resetExpanded}
                    toggleResetExpanded={toggleResetExpanded}
                />
                {/* <ResetZoomButton resetFunction={resetZoom} /> */}
                {paramList && paramList.length ? (
                    <ParamSelectorButton
                        displayParamWindowDropdown={displayParamWindowDropdown}
                        toggleParamWindowDropdown={toggleParamWindowDropdown}
                    />
                ) : null}
                {/* <TimeWindowSelectorButton
                    timeWindow={timeWindow}
                    displayTimeWindowDropdown={displayTimeWindowDropdown}
                    toggleTimeWindowDropdown={toggleTimeWindowDropdown}
                /> */}
                <div className="panelHeaderIconWrapper">
                    {isExpanded ? null : (
                        <CollapseButton
                            name={`sample-aggregate`}
                            isCollapsed={isCollapsed}
                            setCollapsed={setCollapsed}
                        />
                    )}
                    <ExpandButton
                        name={`sample-aggregate`}
                        isExpanded={isExpanded}
                        setIsExpanded={setIsExpanded}
                    />
                    <ChartDownloadButton
                        name={`sample-aggregate`}
                        onDownload={handleDownload}
                        disabled={downloadDisabled}
                    />
                </div>
            </div>
        </PanelHeader>
    )
}
